// src/data/courses/index.ts
// Values live in Firestore (gameConfig/courses); this module only reads them.
// The former per-category arrays are now derived from each course's `category` field.
import { Course } from '../../types';
import { getDomain } from '../../config/gameConfig';

export const getAllCourses = (): Course[] => getDomain<Course>('courses');

/**
 * The courses a player is shown: every course not hidden (55.96, the admin's Koolitused), and a hidden one they have
 * already passed — it stays on their record. Names are still looked up through getCourseById, hidden or not.
 */
export const getOfferedCourses = (completed: readonly string[] = []): Course[] => {
    const done = new Set(completed);
    return getAllCourses().filter((c) => !c.hidden || done.has(c.id));
};

// Helper function to get course by ID
export const getCourseById = (courseId: string): Course | undefined => {
    return getAllCourses().find(course => course.id === courseId);
};

// How many courses the game offers (the landing page's count), hidden ones not counted.
export const getTotalCourseCount = (): number => getOfferedCourses().length;
